import { atom } from 'jotai';

/** When true, `AppDownloadPromoAfterLeadingBidHost` should show the LAAC-1674 promo after the absentee auth modal closes. */
export const showAppDownloadPromoAfterLeadingBidExitAtom = atom(false);
